import React from 'react';
import { Nav } from 'react-bootstrap';
import SvgSprite from 'components/html-elements/SvgSprite';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import app from 'srcJs/App';
import { When } from 'react-if';

var Tabs = function Tabs(_ref) {
  var blocks = _ref.blocks,
      onSelect = _ref.onSelect,
      tools = _ref.tools,
      faq = _ref.faq;
  var items = blocks.map(function (block) {
    return /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li",
      key: block.id
    }, /*#__PURE__*/React.createElement(PopoverStickOnHover, {
      placement: "right",
      text: block.label
    }, /*#__PURE__*/React.createElement(Nav.Link, {
      eventKey: block.id,
      className: "menu-panel-platform menu-panel-platform--vertical",
      onSelect: onSelect
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, block.label), /*#__PURE__*/React.createElement(SvgSprite, {
      id: block.id
    }))));
  });
  return /*#__PURE__*/React.createElement(Nav, {
    as: "ul",
    className: "flex-column"
  }, items, /*#__PURE__*/React.createElement(When, {
    condition: !!tools
  }, /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement(PopoverStickOnHover, {
    placement: "right",
    text: app.tForReact('base_menu', 'Tools')
  }, /*#__PURE__*/React.createElement(Nav.Link, {
    eventKey: "tools",
    className: "menu-panel-platform menu-panel-platform--vertical",
    onSelect: onSelect
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, app.tForReact('base_menu', 'Tools')), /*#__PURE__*/React.createElement(SvgSprite, {
    id: "tools"
  }))))), /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement(PopoverStickOnHover, {
    placement: "right",
    text: app.tForReact('base_menu', 'Technical support')
  }, /*#__PURE__*/React.createElement(Nav.Link, {
    eventKey: "support",
    className: "menu-panel-platform menu-panel-platform--vertical",
    onSelect: onSelect
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, app.tForReact('base_menu', 'Technical support')), /*#__PURE__*/React.createElement(SvgSprite, {
    id: "support"
  })))), /*#__PURE__*/React.createElement(When, {
    condition: !!faq
  }, /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li"
  }, /*#__PURE__*/React.createElement(PopoverStickOnHover, {
    placement: "right",
    text: app.tForReact('base_menu', 'FAQ')
  }, /*#__PURE__*/React.createElement(Nav.Link, {
    eventKey: "faq",
    className: "menu-panel-platform menu-panel-platform--vertical",
    onSelect: onSelect
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, app.tForReact('base_menu', 'FAQ')), /*#__PURE__*/React.createElement(SvgSprite, {
    id: "faq"
  }))))));
};

export { Tabs };